var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndeterminate = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.465 7.95 4.95 5.467 7.435 7.95l.515-.515L5.467 4.95 7.95 2.465l-.515-.515L4.95 4.433 2.465 1.95l-.515.515L4.433 4.95 1.95 7.435z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndeterminate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/indeterminate.ffdc091de5784479d2f2c6095687f0d4.svg";